import { withRouter } from "../../../../withRouter";
import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import debounce from "lodash.debounce";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import logo from "../../../../assets/img/givbeeLogo.png";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { ValidatorForm } from "react-material-ui-form-validator";
import PtsAlert from "../../../givBee/ptsAlert/PtsAlert";
import AdminFetchServerData from "../../../../provider/AdminFetchServerData";
import PasswordRequirementsTooltip from "../../../givBee/passwordRequirementsTooltip/passwordRequirementsTooltip";
import {
  ApResetPassword_Url,
  GetTokenData_Url,
} from "../../../../provider/ServiceUrl";

export class AdminResetPasswordViaEmail extends Component {
  constructor(props) {
    super(props);
    const str = new URLSearchParams(window?.location?.search);
    const token = str.get("token");
    if (token) {
      this.getTokenData(token);
    }
    this.state = {
      password: "",
      confirmPassword: "",
      passwordHelperText: "",
      confirmPasswordHelperText: "",
      error: {
        one: true,
        two: true,
        three: true,
        four: true,
        five: true,
      },
      passwordFocussed: false,
      email: "",
      tid: null,
      verificationCode: "",
      showPassword: false,
      showConfirmPassword: false,
    };
  }

  getTokenData(token) {
    const postObject = {
      token: token,
    };
    AdminFetchServerData.callPostService(GetTokenData_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          const paramters = output.data.paramters;
          this.setState({
            email: paramters?.email,
            tid: paramters?.tid,
            verificationCode: paramters?.verificationCode,
          });
        }
      }
    );
  }

  handleClickShowNewPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }
  handleClickShowConfirmPassword() {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  }

  handlePasswordChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
    if (name === "password") {
      this.debouncedValidatePassword(value);
    } else if (name === "confirmPassword") {
      this.debouncedValidatePassword(this.state.password);
    }
  };


  debouncedValidatePassword = debounce(
    (password) => this.validatePassword(password),
    1000
  );

  validatePassword = (password) => {
    const { confirmPassword } = this.state;
    let one = false,
      two = false,
      three = false,
      four = false,
      five = false,
      confirmPasswordHelperText = "";

    if (password.length < 12) {
      one = true;
    }
    if (!password.match(/[A-Z]/)) {
      two = true;
    }
    if (!password.match(/[a-z]/)) {
      three = true;
    }
    if (!password.match(/\d/)) {
      four = true;
    }
    if (!password.match(/\W/)) {
      five = true;
    }
    if (password !== confirmPassword) {
      confirmPasswordHelperText = "Password & confirm password must match";
    }

    if (one || two || three || four || five) {
      this.setState({
        error: { one: one, two: two, three: three, four: four, five: five },
        confirmPasswordHelperText: confirmPasswordHelperText,
        passwordHelperText: "Password requirements not met",
      });
      return;
    }

    this.setState({
      error: {},
      confirmPasswordHelperText: confirmPasswordHelperText,
      passwordHelperText: "",
    });
  };

  handlePasswordConfirmChange(e) {
    this.setState({ confirmPassword: e.target.value });
  }

  toggleFocusNewPassword = () => {
    this.setState((prevState) => {
      return { passwordFocussed: !prevState.passwordFocussed };
    });
  };

  resetPasswordViaEmailLinkBackend() {
    if (this.state.password !== this.state.confirmPassword) {
      return;
    }
    const postObject = {
      header: { tid: this.state.tid },
      appuser: {
        email: this.state.email,
        credential: this.state.password,
        temppassword: this.state.verificationCode,
      },
    };
    AdminFetchServerData.callPostService(ApResetPassword_Url, postObject).then(
      (response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate("/ApLogin");
        }
      }
    );
  }

  render() {
    const { error, passwordFocussed } = this.state;
    return (
      <div className="authentication-wrapper authentication-cover">
        <div className="authentication-inner row m-0" id="signIn">
          <div className="d-flex col-12 col-lg-6 col-xl-6 align-items-center apLeftBackground">
            <div className="mx-auto">
              <div className="logoBackground">
                <img
                  src={logo}
                  className="img-fluid logoImage"
                  alt=""
                  data-app-dark-img="illustrations/girl-with-laptop-dark.png"
                  data-app-light-img="illustrations/girl-with-laptop-light.png"
                />
              </div>
            </div>
          </div>
          <div
            className="d-flex col-12 col-lg-6 col-xl-6 align-items-center authentication-bg p-sm-5 p-4"
            style={{ background: "#fff" }}
          >
            <div className="w-px-400 mx-auto">
              <ValidatorForm
                ref="form"
                id="formAuthentication"
                className="mb-3"
                onSubmit={this.resetPasswordViaEmailLinkBackend.bind(this)}
              >
                <div className="text-start">
                  <h3>Reset Password</h3>
                  <p>
                    We will send you an email that will allow you to reset
                    your password.
                  </p>
                </div>
                <div className="mb-3 form-password-toggle">
                  <label
                    className="form-label bold"
                    htmlFor="collapsible-companyName"
                  >
                    Enter New Password
                    {this.state.passwordHelperText ? (
                      <PasswordRequirementsTooltip
                        error={error}
                        open={passwordFocussed}
                        style={{
                          float: "right",
                          marginTop: "-1em",
                        }}
                      />
                    ) : (
                      ""
                    )}{" "}
                  </label>
                  <div className="input-group input-group-merge">
                    <input
                      type={this.state.showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      className="form-control"
                      aria-describedby="multiStepsPass2"
                      onChange={this.handlePasswordChange.bind(this)}
                      value={this.state.password}
                      onFocus={this.toggleFocusNewPassword}
                      onBlur={this.toggleFocusNewPassword}
                      helperText={this.state.passwordHelperText}
                      error={this.state.passwordHelperText !== ""}
                    />
                    <span
                      className="input-group-text cursor-pointer"
                      id="multiStepsPass2"
                      onClick={this.handleClickShowNewPassword.bind(this)}
                    >
                      {this.state.showPassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </span>
                  </div>
                </div>
                <div className="mb-3 form-password-toggle">
                  <label
                    htmlFor="new-password"
                    className="form-label bold"
                  >
                    Confirm Password
                  </label>
                  <div className="input-group input-group-merge">
                    <input
                      id="confirmPassword"
                      name="confirmPassword"
                      className="form-control"
                      aria-describedby="multiStepsConfirmPass2"
                      value={this.state.confirmPassword}
                      type={
                        this.state.showConfirmPassword ? "text" : "password"
                      }
                      helperText={this.state.confirmPasswordHelperText}
                      error={this.state.confirmPasswordHelperText !== ""}
                      onChange={this.handlePasswordChange.bind(this)}
                    />
                    <span
                      className="input-group-text cursor-pointer"
                      id="multiStepsPass2"
                      onClick={this.handleClickShowConfirmPassword.bind(this)}
                    >
                      {this.state.showConfirmPassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </span>
                  </div>
                  {this.state.confirmPasswordHelperText && (
                    <p style={{ color: "red", fontSize: "13px" }}>
                      {this.state.confirmPasswordHelperText}
                    </p>
                  )}
                </div>
                <button className="siginButton d-grid w-100 mt-2">
                  {" "}
                  Reset Password{" "}
                </button>
              </ValidatorForm>
              <div className="d-flex flex-row">
                <NavLink className="pt-1" to="/ApLogin">
                  <ArrowBackIosNewIcon />
                  Back Sign In
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AdminResetPasswordViaEmail);
